import { ISearchSuggestionProps } from '@1js/search-types';
import React from 'react';
import { ClassNames } from '../../shared/icon-font/icon-font-classes.utility';
import { IconFontType } from '../../shared/icon-font/icon-font-type.enum';
import { LaunchAction, UrlLauncherService } from '../../shared/services/url-launcher.service';
import { SearchInstrumentationService, SearchResultElementId, SearchResultType } from '../search-instrumentation.service';
import { SearchSuggestionButtonComponent } from './search-suggestion-components/search-suggestion-button.component';

interface TemplateProps extends ISearchSuggestionProps {
    readonly isPwa: boolean;
    readonly isDarkMode: boolean;
    readonly searchInstrumentationService: SearchInstrumentationService;
    readonly urlLauncherService: UrlLauncherService;
    readonly urlToOpen: string;
    readonly title?: string;
    readonly matchedTemplate?: string;
    readonly style?: string;
    readonly handleClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
}

export class TemplateSuggestionComponent extends React.Component<TemplateProps> {

    public readonly handleClick = () => (e: React.MouseEvent | React.KeyboardEvent) => {

        e.preventDefault();
        this.props.urlLauncherService.openUrl(this.props.urlToOpen, LaunchAction.OpenAutosuggestTemplate).then(() => {
            this.props.searchInstrumentationService.logSearchClickEvent(
                                                        SearchResultType.Template,
                                                        SearchResultElementId.Template,
                                                        true,
                                                        SearchResultType.Template,
                                                        this.props.matchedTemplate,
                                                        undefined,
                                                        undefined,
                                                        this.props.id);
        });
    }

    public render() {
        const iconClass = ClassNames.FluentIconCssClass;
        const iconSVGClass = ClassNames.SvgIconCssClass;
        return (
            <SearchSuggestionButtonComponent
                title={this.props.title}
                handleClick={this.props.handleClick ? this.props.handleClick : this.handleClick()}
                icon={iconSVGClass + ' ' +
                      iconClass + ' ' +
                      ClassNames.getCssClass(IconFontType.PreviewLink) +
                      (this.props.isDarkMode && this.props.isPwa ? ' ms-ohp-Icon--see-more--darkMode' : ' ms-ohp-Icon--see-more')}
                target='_blank'
                style={this.props.style}
                isDarkMode={this.props.isDarkMode}
                isPwa={this.props.isPwa}
            />
        );
    }
}
